export const typeguardForString = (value: unknown): string | undefined =>
  typeof value === 'string' ? value : undefined;
